import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #CHECKBOX-FIELD
\*------------------------------------ */
/**
 * 1) Fieldset of items where multiple items can be selected
 */
.cat-c-fieldset {
  color: var(--cat-theme-color-content-xstrong);
  border: none;
  margin: 0;
  padding: 0;
}

/**
 * checkbox notation
 * 1) If the checkbox has notation, then the notation label will display
 */
.cat-c-fieldset__notation {
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
  margin-inline: var(--cat-space-3x-small);
  color: var(--cat-theme-color-content-subtle);
}
.cat-c-fieldset--disabled .cat-c-fieldset__notation {
  color: var(--cat-theme-color-content-disabled);
}

/**
 * Inverted fieldset
 */
.cat-c-fieldset--inverted {
  color: var(--cat-theme-color-content-knockout);
  --cat-radio-field-color: var(--cat-theme-color-content-knockout);
  --cat-checkbox-field-color: var(--cat-theme-color-content-knockout);
  --cat-radio-field-color-background: none;
}

/**
 * Disabled fieldset
 */
.cat-c-fieldset--disabled {
  cursor: not-allowed;
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-fieldset--disabled .cat-c-fieldset__body {
  pointer-events: none;
}

/**
 * fieldset legend
 */
.cat-c-fieldset__legend {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-block-end: var(--cat-space-3x-small);
}

/**
 * fieldset list
 */
.cat-c-fieldset__list {
  list-style: none;
  margin: 0;
  padding: 0;
  /**
   * Display the checkbox/radio iitems in a horizontal list
   */
}
.cat-c-fieldset--horizontal .cat-c-fieldset__list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--cat-space-x-small);
}

/**
 * Shared styles in slotted checkbox and radio field
 */
.cat-c-fieldset--horizontal ::slotted(cat-checkbox-field) {
  display: block;
}

/**
 * Slotted fieldset items
 * 1) Remove margin top from items when horizontal orientation
 */
.cat-c-fieldset--horizontal ::slotted(cat-checkbox-field) {
  --cat-checkbox-field-margin-top: 0;
}

/**
 * Slotted radio field
 * 1) Remove margin top from items when horizontal orientation
 */
.cat-c-fieldset--horizontal ::slotted(cat-radio-field) {
  --cat-radio-field-margin-top: 0;
}

/**
* error/warning icons and note wrapped inside
*/
.cat-c-errornote {
  display: flex;
}

/**
* error/warning icons scss
*/
.cat-c-fieldset__error-icon {
  margin-inline: var(--cat-space-x-small) var(--cat-space-3x-small);
  margin-block-start: var(--cat-space-3x-small);
}

/**
* Setting styles for field note
*/
cat-field-note {
  --cat-field-note-margin-block-start: 0;
  margin-inline: var(--cat-space-x-small) var(--cat-space-3x-small);
  margin-block-start: var(--cat-space-3x-small);
}
cat-field-note slot[name=error],
cat-field-note slot[name=warning] {
  margin-inline-start: var(--cat-space-x-small);
}
cat-field-note slot[name=field-note] {
  margin-inline-start: calc(var(--size-base-unit) * 4.5);
}
.cat-c-checkbox-field--hidden-fieldNote cat-field-note {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.cat-c-fieldset:not(.cat-c-fieldset--has-error) [part=error-note], .cat-c-fieldset:not(.cat-c-fieldset--has-warning) [part=warning-note], .cat-c-fieldset:not(.cat-c-fieldset--has-field-note) .cat-c-fieldset-fieldnote-slot {
  display: none;
}
`;
       